import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from "@progress/kendo-react-grid";

export const PdsrRelationUpdateModeColumnMenu = (props: GridColumnMenuProps) => (
  <GridColumnMenuCheckboxFilter
    expanded
    filterable
    data={[{ State: "Active" }, { State: "Expired" }, { State: "Manual" }]}
    searchBox={() => null}
    {...props}
  />
);
